type RangeValues = {
  min: number;
  max: number;
};

const CRITICISE_ZONE_RANGE_VALUES: RangeValues = { min: -100, max: 0 };
const IMPROVEMENT_ZONE_RANGE_VALUES: RangeValues = { min: 1, max: 50 };
const QUALITY_ZONE_RANGE_VALUES: RangeValues = { min: 51, max: 75 };
const EXCELENCE_ZONE_RANGE_VALUES: RangeValues = { min: 76, max: 100 };

export const NPS_CHART_VALUE_BY_ZONE = {
  criticize: 25,
  improvement: 62.5,
  quality: 81.25,
  excelence: 93.75,
};

function numberInRange(num: number, { min, max }: RangeValues) {
  return !!(num >= min && num <= max);
}

export const getChartNpsValueByScore = (score?: number) => {
  if (score === null || score === undefined) return 0;

  if (numberInRange(score, CRITICISE_ZONE_RANGE_VALUES))
    return NPS_CHART_VALUE_BY_ZONE.criticize;
  if (numberInRange(score, IMPROVEMENT_ZONE_RANGE_VALUES))
    return NPS_CHART_VALUE_BY_ZONE.improvement;
  if (numberInRange(score, QUALITY_ZONE_RANGE_VALUES))
    return NPS_CHART_VALUE_BY_ZONE.quality;
  if (numberInRange(score, EXCELENCE_ZONE_RANGE_VALUES))
    return NPS_CHART_VALUE_BY_ZONE.excelence;

  return 0;
};
